// @flow

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { css } from 'glamor';

import UIStore from '~/stores/ui-store';

const spin = css.keyframes({
    from: {
        transform: 'rotate(0deg)',
    },
    to: {
        transform: 'rotate(360deg)',
    },
});

const rule = css({
    display: 'block',
    margin: '0 auto',
    width: '44px',
    height: '44px',
    zIndex: 1,
    animation: spin,
    animationDuration: '2s',
    animationIterationCount: 'infinite',
    animationTimingFunction: 'linear',
    opacity: 0,

    transition: 'opacity 0.5s ease',
});

const loadingRule = css({
    opacity: 1,
});

@observer
export default class Loader extends Component {
    render() {
        const { isLoading } = UIStore;
        const loading = isLoading ? loadingRule : null;

        return (
            <div>
                <img
                    { ...rule }
                    { ...loading }
                    src="/assets/images/logo-small.svg"
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/global/Loader/index.js